<script setup lang="ts">
    import { cn } from '@/lib/utils';
    import { DropdownMenuSeparator, type DropdownMenuSeparatorProps } from 'reka-ui';
    import { computed, reactive, type HTMLAttributes } from 'vue';

    const props = defineProps<
        DropdownMenuSeparatorProps & {
            class?: HTMLAttributes['class'];
        }
    >();

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return reactive(delegated);
    });
</script>

<template>
    <DropdownMenuSeparator
        data-slot="dropdown-menu-separator"
        v-bind="delegatedProps"
        :class="cn('bg-border -mx-1 my-1 h-px', props.class)"
    />
</template>
